import { render, staticRenderFns } from "./UnavailableProductsDialog.vue?vue&type=template&id=60a2e2ac&scoped=true"
import script from "./UnavailableProductsDialog.vue?vue&type=script&lang=js"
export * from "./UnavailableProductsDialog.vue?vue&type=script&lang=js"
import style0 from "./UnavailableProductsDialog.vue?vue&type=style&index=0&id=60a2e2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2e2ac",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Funavailable-products-dialog%2FUnavailableProductsDialog.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports